/**
 * The two groups /biblioteca can be narrowed to by its `source` parameter: this library's own
 * holdings, or the international catalogues it links out to. No `source` shows both.
 */
export const LIBRARY_SOURCE = {
  national: 'national',
  international: 'international',
} as const;
